// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ArrowLeftSvg from '@rsuite/icon-font/lib/direction/ArrowLeft';
var ArrowLeft = createSvgIcon({
    as: ArrowLeftSvg,
    ariaLabel: 'arrow left',
    category: 'direction',
    displayName: 'ArrowLeft'
});
export default ArrowLeft;
